// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"f42dc8a7","372":"1c6600e1","442":"4f72ebc0","487":"8f729772","788":"a85373b1"}[chunkId] + ".chunk.css";
};